import queryString from 'query-string';
import { validateQueryParameters } from '~/helpers/verifyQueryParameters';
import { createAxiosInstance } from '~/plugins/axios.plugin';

export class MessageService {
  static SERVICE_NAME = 'messages';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.MESSAGES_API,
      useAccessToken : true
    });
  }

  getRoleConfigurations() {
    return this.client.get('/institutions/role-configuration');
  }

  getMessagesResume(params) {
    const stringified = queryString.stringify(params, { skipNull: true, skipEmptyString: true });
    let url = '/messages/resume';

    if (stringified) {
      url += `?${stringified}`;
    }

    return this.client.get(url);
  }

  getUnreadMessages(params) {
    const query = validateQueryParameters({
      perPage            : params.perPage || 10,
      page               : params.page,
      contextExternalIds : params.selectedCourseIds.join(),
      contextType        : 'course',
      startAt            : params.startDate,
      endAt              : params.endDate,
      externalUserIds    : params.externalUserIds.join(),
      isRead             : params.isRead || false
    }, { skipNull: true, skipEmptyString: true });
    return this.client.get(`/messages?${query}`)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error.response.data.error));
  }
};

export default new MessageService();
